export interface AmplitudUser {
  id: string;
  clientId: string;
  email: string | null;
  initials: string;
  fullName: string;
  hostPlatform: string;
  vitallyCompanyId?: string;
  userType: `${PermissionLevelLabel}`,
  modules: Array<`${CompanyModules}`>,
}

export enum ModuleName {
  COMPETENCIES = 'dpc',
  LEARNING = 'cya',
  EVALUATIONS = 'eva',
  OBJECTIVES = 'obj',
}

export enum PermissionLevelLabel {
  A = 'Administrador',
  I = 'Instructor',
  P = 'Colaborador',
  L = 'Lite',
}

export enum CompanyModules {
  competencies = "Desarrollo por competencias",
  pid = "Desarrollo por competencias - Plan individual de desarrollo",
  diagnoses = "Desarrollo por competencias - Diagnóstico por competencias",
  learning = "Capacitación y aprendizaje",
  certifiers = "Capacitación y aprendizaje - Certificaciones de evaluaciones presenciales",
  community = "Comunidad",
  evaluations = "Evaluaciones",
  performance = "Objetivos",
  stps = "STPS",
  catalog_tec = "catalog_tec",
  catalog_team = "catalog_team",
  template = "template",
  climate = "climate",
  jobs = "jobs",
}